<app-type-marche-reserve
	[uid]="getUid()"
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[reservationMarche]="oui?.reservationMarche"
>
</app-type-marche-reserve>
